import { NavLink, useLocation } from 'react-router-dom';
import {
    PiArrowRightBold,
    PiBriefcaseDuotone,
    PiFileTextDuotone,
    PiNewspaperClippingDuotone,
    PiPhoneDuotone,
    PiQuestionDuotone,
    PiShoppingCartDuotone,
    PiSignInDuotone,
    PiUserPlusDuotone,
    PiXBold,
} from 'react-icons/pi';

import SocialList from 'components/SocialList';

import { useConfig } from 'providers/ConfigProvider';
import { useWebsite } from 'providers/WebsiteProvider';
import { resolveSubsiteMenuPath } from 'utils/SubsiteUtils';

const MENU_ICONS = {
    '/diakmunka': PiBriefcaseDuotone,
    '/kapcsolat': PiPhoneDuotone,
    '/jo-tudni': PiQuestionDuotone,
    '/jo-tudni-meki': PiQuestionDuotone,
    '/jo-tudni-gyakornok': PiQuestionDuotone,
    '/blog': PiNewspaperClippingDuotone,
    '/shop': PiShoppingCartDuotone,
    '/digitalis-ugyintezes': PiFileTextDuotone,
    '/regisztracio': PiUserPlusDuotone,
    '/bejelentkezes': PiSignInDuotone,
};

export default function MobileMenu(props) {
    const { setMobileMenuOpen } = useWebsite();

    return (
        <aside className={`fixed right-0 top-0 h-dvh w-72 py-4 ${props.className || ''}`} aria-label="Mobil navigáció">
            <div className="flex h-full w-full flex-col overflow-hidden rounded-l-3xl border border-r-0 border-white/10 bg-neutral-800 text-white shadow-2xl">
                <header className="gradient-green relative z-10 flex items-center gap-3 rounded-bl-3xl p-4 shadow-xl">
                    <img className="h-8 min-w-0 flex-1 object-left object-contain" src="/assets/images/logo/logo_white.svg" alt="Fürge Diák" />
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(false)}
                        className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white ring-1 ring-white/20 transition hover:bg-white/25 active:scale-95"
                        aria-label="Menü bezárása"
                    >
                        <PiXBold className="size-5" />
                    </button>
                </header>

                <div className="theme-scrollbar min-h-0 flex-1 overflow-y-auto px-3 py-5">
                    <Menu />
                </div>

                <footer className="relative z-10 rounded-tl-3xl bg-neutral-900 p-4 shadow-2xl">
                    <SocialList className="justify-between" />
                </footer>
            </div>
        </aside>
    );
}

function Menu() {
    const { menuItems } = useConfig();
    const { setMobileMenuOpen } = useWebsite();
    const { pathname } = useLocation();

    return (
        <nav className="flex flex-col gap-2">
            {menuItems.map((item) => {
                const path = resolveSubsiteMenuPath(item.path, pathname);

                return (
                    <MenuItem
                        key={item.label}
                        data={{ ...item, path }}
                        onClick={() => setMobileMenuOpen(false)}
                    />
                );
            })}
        </nav>
    );
}

function MenuItem({ data, onClick }) {
    const Icon = MENU_ICONS[data.path] || PiArrowRightBold;
    const isRegistration = data.path === '/regisztracio';
    const isLogin = data.path === '/bejelentkezes';

    return (
        <NavLink
            to={data.path}
            onClick={onClick}
            className={({ isActive }) => {
                const stateClassName = isActive
                    ? 'bg-white text-neutral-900 shadow-lg'
                    : isRegistration
                        ? 'gradient-green text-white hover:brightness-110'
                        : isLogin
                            ? 'gradient-blue text-white hover:brightness-110'
                            : 'text-white/80 hover:bg-white/10 hover:text-white';

                return `group flex min-h-12 items-center gap-3 rounded-2xl px-3 py-2.5 font-display text-sm font-bold transition active:scale-[0.98] ${stateClassName}`;
            }}
        >
            {({ isActive }) => (
                <>
                    <span className={`flex size-9 shrink-0 items-center justify-center rounded-xl text-xl transition ${isActive ? 'bg-green-50 text-green-600' : 'bg-white/10 text-white'}`}>
                        <Icon />
                    </span>
                    <span className="min-w-0 flex-1 capitalize">{data.label}</span>
                    <PiArrowRightBold className={`size-4 shrink-0 transition group-hover:translate-x-0.5 ${isActive ? 'text-green-600' : 'text-white/35'}`} />
                </>
            )}
        </NavLink>
    );
}
